import HTTP from "@/_helpers/http";
import { LOWBALANCEACCOUNTS__API } from "@/_helpers/urls";
import { LOWBALANCEACCOUNTS__MUTATIONS } from "../mutation-types";
import { LOWBALANCEACCOUNTS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  accounts: [],
  totalAccounts: 0,
  totalBalance: 0,
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [LOWBALANCEACCOUNTS__MUTATIONS.LOWBALANCEACCOUNTS](state, data) {
    state.accounts = data?.data?.accounts;
    state.totalAccounts = data?.data?.totalAccounts;
    state.totalBalance = data?.data?.totalBalance;
    state.pagination = data?.data?.pagination;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [LOWBALANCEACCOUNTS__ACTIONS.LOWBALANCEACCOUNTS]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
      const {
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${LOWBALANCEACCOUNTS__API.LOWBALANCEACCOUNTS}${queryParams ? `?${queryParams}` : ''}`
      );
      commit(LOWBALANCEACCOUNTS__MUTATIONS.LOWBALANCEACCOUNTS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },
  async [LOWBALANCEACCOUNTS__ACTIONS.LOWBALANCEACCOUNTDISABLE]({ commit }, parameters) {
    try {
      const url = LOWBALANCEACCOUNTS__API.LOWBALANCEACCOUNTDISABLE;
      const allResponses = [];

      for(let parameter of parameters) {
        try {
          const response = await HTTP().patch(url, parameter);
          if (response.status === 200) {
            allResponses.push({ success: true, message: response.data.message || "Updated Successfully" });
          }
        } catch (error) {
          console.log(error);
          allResponses.push({ success: false, message: error.response?.data?.message || "Failed to update" });
        }
      }

      if (allResponses.length > 1) {
        const successCount = allResponses.filter(res => res.success).length;
        const errorCount = allResponses.filter(res => !res.success).length;
  
        if (errorCount === 0) {
          toast.success(`All ${successCount} rows disabled and deleted successfully!`);
        } else if (successCount === 0) {
          toast.error(`All ${errorCount} rows failed to disable and delete.`);
        } else {
          toast.warning(`${successCount} rows disabled and deleted successfully, ${errorCount} rows failed.`);
        }
      } else {
        toast.success(`row disabled and deleted successfully`);
      }
    } catch (error) {
      console.log(error);
      toast.error("An unexpected error occurred while processing the request.");
    }
  }
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
